import { ReactComponentManifest } from "web/entrypoints/common/setup";
import { CssRedirectPage } from "web/react/pages/track-redirect/css-redirect-page";
import { TrackRedirectPage } from "web/react/pages/track-redirect/track-redirect-page";

const components: ReactComponentManifest = {
    TrackRedirectPage,
    CssRedirectPage,
};

export default components;
